import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { SplitButton } from 'primereact/splitbutton';
import { useCallback, useEffect, useRef, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { NumericFormat } from 'react-number-format';
import { useNavigate } from 'react-router-dom';
import Header from "../../Layout/Header";
import { getEndpointUrl, getTimestamp } from "../../Utils/Common";
import CreateSection from './CreateSection';
import DeleteSection from './DeleteSection';
import UpdateSection from './UpdateSection';

const FormOptions = () => {
    const [isLoading, setLoading] = useState(true);

    const navigate = useNavigate();

    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const fetchData = useCallback(async () => {
        setLoading(true);

    }, []);

    useEffect(() => {


    }, []);

    const [accesToken] = useState(JSON.parse(localStorage.getItem('credentials')) || []);
    const inputRef = useRef();
    const timeout = useRef();

    const [totalRecords, setTotalRecords] = useState(0);
    const [sections, setSections] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 15,
        page: 0
    });
    const [showCreate, setShowCreate] = useState(false);
    const [showUpdate, setShowUpdate] = useState(false);
    const [updateData, setUpdateData] = useState(null);
    const [showDelete, setShowDelete] = useState(false);
    const [deleteData, setDeleteData] = useState(null);

    const loadLazyData = () => {
        setLoading(true);

        fetch(getEndpointUrl() + `/v2/form_sections?page=${lazyParams.page}&per_page=${lazyParams.rows}&query=${globalFilterValue}&v=${getTimestamp()}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setTotalRecords(json.results.total);
                setSections(json.results.data);
            }
            setLoading(false);
        });
    };

    const onPage = (event) => {
        setLazyParams(event);
    };

    useEffect(() => {
        return () => loadLazyData();
    }, [lazyParams]);

    useEffect(() => {
        clearTimeout(timeout.current);

        if (!globalFilterValue.trim()) {
            loadLazyData();
            return;
        }
        timeout.current = setTimeout(() => {
            loadLazyData();
        }, 600);
    }, [globalFilterValue]);

    const onGlobalFilterChange = (e) => {
        setLoading(true);
        lazyParams.page = 0;
        setTotalRecords(0);
        setSections([]);
        setGlobalFilterValue(e.target.value);
    };

    const header = (
        <Row>
            <Col md={4} sm={12} className="my-2">
                <h5 className="me-auto fw-bold pt-2">Form Sections</h5>
            </Col>
            <Col md={8} sm={12} className="d-flex justify-content-end gap-2">
                <div>
                    <div className="p-input-icon-left">
                        <i className="pi pi-search" />
                        <InputText
                            ref={inputRef}
                            className="p-inputtext-sm"
                            onChange={onGlobalFilterChange}
                            placeholder="Pencarian..."
                            style={{ minWidth: '100%' }}
                        />
                    </div>
                </div>
                <div>
                    <Button
                        className="btn btn-secondary"
                        onClick={() => {
                            setShowCreate(true);
                        }}>
                        Tambah Section
                    </Button>
                </div>
            </Col>
        </Row>
    );

    const kelolaBodyTemplate = (rowData) => {
        return <SplitButton size="small" label="Lihat detil" icon="pi pi-eye"
            onClick={(e) => {
                navigate(`/form-options/${rowData.id}`);
            }}
            model={[
                {
                    label: 'Edit',
                    icon: 'pi pi-pencil',
                    disabled: userLogin.role != 'admin',
                    command: () => {
                        setUpdateData(rowData);
                        setShowUpdate(true);
                    }
                },
                {
                    label: 'Hapus',
                    icon: 'pi pi-trash',
                    disabled: userLogin.role != 'admin',
                    command: () => {
                        setDeleteData(rowData);
                        setShowDelete(true);
                    }
                }
            ]} severity="secondary" text />
    };
    return (
        <>
            <Helmet>
                <title>Form Inspeksi</title>
            </Helmet>
            <Header />
            <Container className="mt-3">
                <DataTable
                    value={sections}
                    lazy
                    size="small"
                    responsiveLayout="scroll"
                    dataKey="id"
                    header={header}
                    globalFilterFields={['title']}
                    emptyMessage="Tidak ada data yang ditemukan."
                    paginator
                    first={lazyParams.first}
                    rows={15}
                    totalRecords={totalRecords}
                    onPage={onPage}
                    loading={isLoading}>
                    <Column field="id" header="ID" />
                    <Column field="icon" header="ICON" body={(rowData) => 
                        <img src={process.env.REACT_APP_API_URL + `/images/icons/${rowData.icon}`} alt={rowData.title} height={50} />
                    } />
                    <Column field="title" header="JUDUL" />
                    <Column header="JUMLAH OPSI" body={(rowData) =>
                        <NumericFormat
                            value={rowData?.form_elements || 0}
                            displayType={'text'}
                            thousandSeparator={true}
                            className="bg-transparent"
                            prefix={''}
                            renderText={(value, props) => <span {...props}>{value}</span>} />
                    } />
                    <Column header="KELOLA" body={kelolaBodyTemplate} />
                </DataTable>

                <CreateSection
                    show={showCreate}
                    close={() => setShowCreate(false)}
                    onCallback={(newSection) => {
                        setSections((prev) => {
                            const base = Array.isArray(prev) ? prev : [];
                            return [newSection, ...base];
                        });
                        setTotalRecords((prev) => (parseInt(prev || 0, 10) + 1));
                    }}
                />

                <UpdateSection
                    show={showUpdate}
                    close={() => setShowUpdate(false)}
                    data={updateData}
                    onCallback={(updated) => {
                        setSections((prev) => {
                            const base = Array.isArray(prev) ? prev : [];
                            return base.map((s) => (s.id === updated.id ? { ...s, ...updated } : s));
                        });
                    }}
                />

                <DeleteSection
                    show={showDelete}
                    close={() => setShowDelete(false)}
                    data={deleteData}
                    onCallback={(deleted) => {
                        fetchData();
                        setLoading(false)
                    }}
                />
            </Container>
        </>
    );
}

export default FormOptions;
